import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M13.856 5.2V7h-1.5V5.887h-3.11v-3.11h-4.42a1.18 1.18 0 0 0-1.18 1.17v8.18a1.18 1.18 0 0 0 1.18 1.17h3.18v1.5h-3.18a2.678 2.678 0 0 1-2.68-2.67v-8.18a2.678 2.678 0 0 1 2.68-2.67h5.1Zm.77 9.45a.767.767 0 0 1-.53.22.786.786 0 0 1-.53-.22L11.926 13a2.9 2.9 0 1 1 1.06-1.06l1.64 1.65a.737.737 0 0 1 0 1.057Zm-2.75-4.18a1.425 1.425 0 1 0-1.42 1.43 1.425 1.425 0 0 0 1.42-1.433Z';
const draw24px = 'M20.33,7.64v4.29h-1.5V8.64H13.57V3.38H6.68A2.25,2.25,0,0,0,4.43,5.63V18.37a2.25,2.25,0,0,0,2.25,2.25H12v1.5H6.68a3.76,3.76,0,0,1-3.75-3.75V5.63A3.76,3.76,0,0,1,6.68,1.88h7.89Zm2.18,14.87a.75.75,0,0,1-1.06,0L19,20A3.82,3.82,0,1,1,20,19l2.49,2.5A.75.75,0,0,1,22.51,22.51Zm-5.66-3.36a2.31,2.31,0,1,0-2.31-2.31A2.31,2.31,0,0,0,16.85,19.15Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const DocumentMagnifyingGlassIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'documentMagnifyingGlass'));
DocumentMagnifyingGlassIcon.displayName = 'DocumentMagnifyingGlassIcon';
DocumentMagnifyingGlassIcon.propTypes = Icon.propTypes;
DocumentMagnifyingGlassIcon.renderIcon = props => /*#__PURE__*/React.createElement(DocumentMagnifyingGlassIcon, props);
export default DocumentMagnifyingGlassIcon;
//# sourceMappingURL=DocumentMagnifyingGlassIcon.js.map